export const mascaraMoedaReal = (valor: string | number) => {
  let valorNumeral = valor

  if (typeof valor === 'string') {
    const valorFormatado = valor.replace(/[^0-9]+/g, '')
    valorNumeral = Number(valorFormatado) / 100
  }

  return valorNumeral.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  })
}
